import { NOT_SAVED_ID } from "app/model"
import { CURRENCIES } from "currency/model"
import { getDefaultOrderPagination } from "order/tools/list"
import { isDesktopScreen } from "ui/tools/responsive"
import { IOrderFilters, IOrderForm, IOrderFormData, IOrderList, IOrderState } from "../model"

export function getDefaultOrderState(): IOrderState {
  return {
    orders: [],
    forecastOrder: undefined as any, // will be loaded at startup
    list: getDefaultOrderListState(),
    form: getDefaultOrderFormState(),
    isFormPopupOpened: false
  }
}

export function getDefaultOrderFilters(): IOrderFilters {
  return {
    name: ""
  }
}

export function getDefaultOrderFormState(): IOrderForm {
  return {
    hasChanged: false,
    initialData: getDefaultData(),
    data: getDefaultData(),
    errors: {},
    isCreation: true,
    isLoading: false,
    hasLoadingError: false,
    isSaving: false,
    isValid: false,
    orderId: NOT_SAVED_ID
  }
}

function getDefaultData(): IOrderFormData {
  return {
    name: "",
    notes: null,
    budget: null,
    max_impressions: null,
    budget_currency_id: CURRENCIES.USD,
    start_date: null,
    end_date: null,
    unlimitedImpressions: true,
    advertiserNameOrId: null
  }
}

function getDefaultOrderListState(): IOrderList {
  return {
    filteredOrders: [],
    filters: getDefaultOrderFilters(),
    isFilterExpanded: isDesktopScreen(),
    isRefreshing: false,
    hasRefreshError: false,
    pagination: getDefaultOrderPagination(),
    rowCount: 0
  }
}
